/**
 * Component is used to define product summary row structure.
 * The structure could be redefined in BU addon
 *
 * @attr [css-class] - additional css classes
 *
 * Example
 * <e2-product-summary-row>
 *      <div v-slot="name">Product name</div>
 *      <div v-slot="quantity">Quantity: 1</div>
 *       <div v-slot="product-code">Ref: 1234</div>
 * </e2-product-summary-row>
 */

import { html } from 'lit-element';
import { classMap } from 'lit-html/directives/class-map';

import { LightLitElement } from '@elab/components';
import { stringToClassMapToken } from '@elab/core/utils/webComponent';

class ProductSummaryRowLayout extends LightLitElement {
    static get properties() {
        return {
            cssClass: { type: String, attribute: 'css-class' },
        };
    }

    getRowClassName = () =>
        classMap({
            'product-row': true,
            ...(this.cssClass ? stringToClassMapToken(this.cssClass) : null),
        });

    getItemClassName = (item, className) =>
        classMap({
            [`product-row__${item}`]: !!item,
            [className]: !!className,
        });

    render() {
        return html`
            <div class="${this.getRowClassName()}">
                <div class="${this.getItemClassName('image')}">
                    <v-slot name="image"></v-slot>
                </div>
                <div class="product-row__info-container">
                    <div class="product-row__title-section">
                        <div class="product-row__title">
                            <v-slot name="name"></v-slot>
                        </div>
                        <div class="${this.getItemClassName('delete-button')}">
                            <v-slot name="delete-button"></v-slot>
                        </div>
                        <div class="${this.getItemClassName('resend-button')}">
                            <v-slot name="resend-button"></v-slot>
                        </div>
                    </div>
                    <div class="product-row__details-wrap">
                        <div class="product-row__details">
                            <div class="${this.getItemClassName('variants')}">
                                <v-slot name="variants"></v-slot>
                            </div>

                            <div class="${this.getItemClassName('quantity')}">
                                <v-slot name="quantity"></v-slot>
                            </div>
                            <div class="${this.getItemClassName('missed-offer')}">
                                <v-slot name="missed-offer"></v-slot>
                            </div>
                        </div>

                        <div class="product-row__price-container">
                            <div class="${this.getItemClassName('price')}">
                                <v-slot name="price"></v-slot>
                            </div>
                            <div class="${this.getItemClassName('quantity-selector')}">
                                <v-slot name="quantity-selector"></v-slot>
                            </div>
                        </div>
                        <div class="d-none">
                            <v-slot name="brand"></v-slot>
                            <v-slot name="range"></v-slot>
                            <v-slot name="product-code"></v-slot>
                            <v-slot name="unit-price"></v-slot>
                            <v-slot name="discount"></v-slot>
                            <v-slot name="promotion"></v-slot>
                            <v-slot name="gift-card-details"></v-slot>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }
}

export default () =>
    customElements.define('e2-product-summary-row-layout', ProductSummaryRowLayout);
